import React, { Fragment } from 'react';
import { Col, Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Navbarh from '../navbar/Navbar';
import * as IoIcons from 'react-icons/io';
import useClientes from '../../hooks/useClientes';
import '../estilos.css';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//Función principal 
function Clientes() {
  const { pclientes, formType, mensajeAlert, color, aVisible, cargando, formData, clientesCotizacion,
    clientes, estadoCliente, inputElement, isDisabled, contacto, guardarDisable, editarImagen, modal, contactosClientes,
    onDismiss, catalogo, nuevoCliente, fetchClientes, sClienteEstado, onClickCliente, toggle, seleccionarCliente,
    editarCliente, onChanges, onChangeimage, nuevoContacto, createClientes, updateClientes, setClientesCotizacion } = useClientes();

  //Diseño de la página
  return (
    <>
      <Navbarh />
      {pclientes === true && (
        <>
          <row>
            <div className="headerp">
              <IoIcons.IoMdPeople className="iconoc floatleft" onClick={catalogo} />
              <h3 >{formType}</h3>
            </div>
          </row>
          <div className="conteiner5">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>

            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                  <img width="150px" src="assets/img/preloader.gif" />
                </div>
              </Row>
            )}

            {//Catálogo de clientes
              formType === 'Catálogo' && (
                <Fragment>
                  {!formData.cliente && (
                    <>
                      <Row>
                        <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 text-left " >
                          <button class="cbutton btn-success margintop20px " onClick={nuevoCliente}> <span class="fa fa-plus"> Agregar cliente</span> </button>
                          <button className="cbutton btn-dark floatright  ml-2 " title="Recargar página" onClick={() => { fetchClientes(); }}><IoIcons.IoMdRefresh /> Recargar </button>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-left " >
                          <Label>Mostrando clientes</Label>
                          <select name="clienteestado " className="floatleft custom-select" onChange={sClienteEstado}>
                            <option value="todos" >Todos</option>
                            <option value="true">Activos</option>
                            <option value="false">Inactivos</option>
                          </select>
                        </div>
                      </Row>
                      <div>
                      </div>
                      <Row>
                        {clientes.map(cliente => (
                          <>
                            {estadoCliente === "todos" && (
                              <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                                {
                                  <div>
                                    {
                                      cliente.image && <img src={cliente.image} alt="logo del cliente" width="100px" onClick={() => onClickCliente(cliente)} className="cursorpointer" />
                                    }
                                    <h4>{cliente.cliente} </h4>
                                    <h4>{cliente.activo}</h4>
                                  </div>
                                }
                              </div>)
                            }
                            {estadoCliente === cliente.activo.toString() && (
                              <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                                {
                                  <div>
                                    {
                                      cliente.image && <img src={cliente.image} alt="logo del cliente" width="100px" onClick={() => onClickCliente(cliente)} className="cursorpointer" />
                                    }
                                    <h4>{cliente.cliente} </h4>
                                    <h4>{cliente.activo}</h4>
                                  </div>
                                }
                              </div>)
                            }
                          </>
                        )
                        )
                        }
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(resultados)}</div>*/}
                      </Row> </>
                  )}
                  {formData.cliente && (
                    <div className="textaligmentleft">
                      <Row className="margintop20px ">
                        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                          <img src={formData.image} alt="imagen" width="100px" />
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                          <button class=" btn-primary cbutton " color="primary" onClick={editarCliente} title="Editar"> <IoIcons.IoIosCreate />Editar </button>
                        </div>
                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                          <button class="btn-info cbutton floatleft" onClick={catalogo} title="Regresar"> <IoIcons.IoMdArrowRoundBack />Regresar </button>
                        </div>
                      </Row>
                      <Row>
                        <h4 className="col-lg-12 col-md-12 col-sm-12 col-xs-12">{formData.cliente}</h4>
                        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 ">
                          <Label>CLIENTE {formData.activo ? "ACTIVO" : "INACTIVO"}</Label>
                        </div>
                      </Row>
                      <Row>
                        <div className="margintop20px col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <Label>INFORMACIÓN DEL CLIENTE</Label>
                        </div>
                        <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12"> {formData.descripcion}</p>
                      </Row>
                      <Row>
                        <div>
                          <div >
                            <div className="margintop20px  col-lg-12 col-md-12 col-sm-12 col-xs-12 "><p>{formData.pais.toUpperCase()}</p> </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12" ><p>{formData.domicilio} {formData.colonia}, {formData.ciudad}, {formData.estado}.</p> </div>
                            <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop-16px">Código Postal: {formData.codigoPostal}</p>
                          </div>
                        </div>
                      </Row>

                      <Row>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                          <Label >Teléfonos</Label>
                          <p> {formData.telefono}</p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                          <Label >Correos</Label>
                          <p> {formData.correo}</p>
                        </div>
                      </Row>
                      <Row>
                        <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">FACTURACIÓN</p>
                      </Row>
                      <p >Tipo: {formData.facturaTipo}</p>
                      {formData.facturaTipo === "Factura foliada" && (<p className="margintop-16px">Requiere IVA: {formData.requiereIVA === true ? 'Sí' : 'No'}</p>)}
                      {formData.requiereIVA === true && (<p className="margintop-16px">Porcentaje de IVA: {formData.porcentajeIVA}</p>)}
                      <p className="margintop-16px">RFC: {formData.rfc}</p>
                      <p className="margintop-16px">Razón social: {formData.razonSocial}</p>
                      <p className="margintop-16px">Uso del CFDI: {formData.usoCFDI}</p>
                      <p>Bill To: {formData.billTo}</p>
                      <p className="margintop-16px">Ship To: {formData.shipTo}</p>
                      <Row>
                        <p className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">CONTACTO</p>
                      </Row>
                      <Row>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll mb-5">
                          <Table className=" mb-2 scroll " >
                            <Thead class="thead-secondary">
                              <Tr>
                                <Th>Número</Th>
                                <Th className="minwidth200px">Contacto</Th>
                                <Th >Puesto</Th>
                                <Th>Teléfono</Th>
                                <Th >Correo</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {contactosClientes.map((contacto, i) => (
                                <Tr class={(i % 2) !== 0 ? "table-active" : ""} >
                                  <Td>{i + 1}</Td>
                                  <Td>{contacto.nombreContacto}</Td>
                                  <Td >{contacto.puestoContacto}</Td>
                                  <Td>{contacto.telefonoContacto}</Td>
                                  <Td >{contacto.correoContacto}</Td>
                                </Tr>

                              ))}
                            </Tbody>
                          </Table>
                        </div>
                      </Row>
                    </div>)}

                </Fragment>
              )
            }
            {//Nuevo cliente
              formType === 'Nuevo cliente' && (
                <Fragment>
                  <Row >
                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Nombre*</Label>
                        <div class="input-group">
                          <Input name="cliente" value={formData.cliente} maxLength={50} placeholder="Nombre del cliente" onChange={onChanges} />
                          <div class="input-group-prepend">
                            <button class="cbuttonS floatleft"
                              title="Obtener cliente de cotización"
                              onClick={toggle}
                            >
                              <IoIcons.IoIosList />
                            </button>
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <div className="col-lg-5 col-md-10 col-sm-10 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Logo del cliente*</Label>
                        {<Input
                          type="file"
                          onChange={onChangeimage}
                        />}
                      </FormGroup>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-2 col-xs-12">
                      <Label for="activo" className="activofloat" >Activo* </Label>
                      <select name="activo" id="activo" className="activofloat custom-select" onChange={onChanges}>
                        <option selected={formData.activo === "true" ? true : false} value="true">Sí</option>
                        <option selected={formData.activo === "false" ? true : false} value="false">No</option>
                      </select>
                    </div>
                  </Row>
                  <Row >
                    <Col>
                      <FormGroup >
                        <Label className="floatleft" >Descripción</Label>
                        <Input name="descripcion" value={formData.descripcion} maxLength={800} type="textarea" placeholder="Descripción" ref={inputElement} onChange={onChanges} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row >
                    <Col>
                      <FormGroup >
                        <Label className="floatleft" >Domicilio*</Label>
                        <Input name="domicilio" value={formData.domicilio} maxLength={300} type="textarea" placeholder="Domicilio" onChange={onChanges} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Colonia*</Label>
                        <Input name="colonia" value={formData.colonia} maxLength={30} placeholder="Colonia" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Ciudad*</Label>
                        <Input name="ciudad" value={formData.ciudad} maxLength={30} placeholder="Ciudad" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Estado*</Label>
                        <Input name="estado" value={formData.estado} maxLength={30} placeholder="Estado" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >País*</Label>
                        <Input name="pais" value={formData.pais} maxLength={15} placeholder="País" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Código Postal*</Label>
                        <Input name="codigoPostal" value={formData.codigoPostal} maxLength={10} placeholder="Código postal" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row  >
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfonos*</Label>
                        <Input name="telefono" value={formData.telefono} maxLength={100} placeholder="Teléfono" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correos*</Label>
                        <Input name="correo" value={formData.correo} maxLength={100} placeholder="Correo" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                      <h4 className="floatleft">Facturación</h4>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                      <Label for="facturaTipo" className="floatleft" >Tipo </Label>
                      <select name="facturaTipo" id="facturaTipo" className="activofloat custom-select" onChange={onChanges}>
                        <option selected={formData.facturaTipo === "Invoice " ? true : false} value="Invoice ">Invoice </option>
                        <option selected={formData.facturaTipo === "Factura foliada" ? true : false} value="Factura foliada">Factura foliada</option>
                      </select>
                    </div>
                    {formData.facturaTipo === "Factura foliada" && (
                      <>
                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                          <Label for="requiereIVA" className="floatleft" >Requiere IVA </Label>
                          <select name="requiereIVA" id="requiereIVA" className="activofloat custom-select" onChange={onChanges}>
                            <option selected={formData.requiereIVA === false ? true : false} value="false">No</option>
                            <option selected={formData.requiereIVA === true ? true : false} value="true">Sí</option>
                          </select>
                        </div>
                        {(formData.requiereIVA === "true" || formData.requiereIVA === true) && (
                          <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <Label for="porcentajeIVA" className="floatleft" >Porcentaje de IVA </Label>
                            <select name="porcentajeIVA" id="porcentajeIVA" className="activofloat custom-select" onChange={onChanges}>
                              <option selected={formData.porcentajeIVA === "8 %" ? true : false} value="8 %">8 %</option>
                              <option selected={formData.porcentajeIVA === "16 %" ? true : false} value="16 %">16 %</option>
                            </select>
                          </div>
                        )}
                      </>
                    )}
                  </Row>
                  <Row>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                      <FormGroup >
                        <Label className="floatleft" >RFC</Label>
                        <Input name="rfc" value={formData.rfc} maxLength={30} placeholder="RFC" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                      <FormGroup >
                        <Label className="floatleft" >Razón social</Label>
                        <Input name="razonSocial" value={formData.razonSocial} maxLength={50} placeholder="Razón social" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 margintop20px">
                      <FormGroup >
                        <Label className="floatleft" >Uso del CFDI</Label>
                        <Input name="usoCFDI" value={formData.usoCFDI} maxLength={50} placeholder="Uso del CFDI" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft " >Bill To</Label>
                        <Input name="billTo" value={formData.billTo} type="textarea" placeholder="Bill To" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Ship To</Label>
                        <Input name="shipTo" value={formData.shipTo} type="textarea" placeholder="Ship To" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                      <h4 className="floatleft">Contacto</h4>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                      <button class="btn-success  floatright" disabled={isDisabled} onClick={nuevoContacto} title="Agregar contacto"> <span class="fa fa-plus lg"></span> </button>
                    </div>
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Nombre*</Label>
                        <Input name="nombreContacto" value={formData.nombreContacto} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Puesto*</Label>
                        <Input name="puestoContacto" value={formData.puestoContacto} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfono*</Label>
                        <Input name="telefonoContacto" value={formData.telefonoContacto} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correo*</Label>
                        <Input name="correoContacto" value={formData.correoContacto} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  {contacto > 1 && (
                    <Row  >
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Nombre</Label>
                          <Input name="nombreContacto1" value={formData.nombreContacto1} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Puesto</Label>
                          <Input name="puestoContacto1" value={formData.puestoContacto1} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Teléfono</Label>
                          <Input name="telefonoContacto1" value={formData.telefonoContacto1} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Correo</Label>
                          <Input name="correoContacto1" value={formData.correoContacto1} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                    </Row>
                  )}
                  {contacto > 2 && (
                    <Row  >
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Nombre</Label>
                          <Input name="nombreContacto2" value={formData.nombreContacto2} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Puesto</Label>
                          <Input name="puestoContacto2" value={formData.puestoContacto2} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Teléfono</Label>
                          <Input name="telefonoContacto2" value={formData.telefonoContacto2} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Correo</Label>
                          <Input name="correoContacto2" value={formData.correoContacto2} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                    </Row>
                  )}
                  {contacto > 3 && (
                    <Row  >
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Nombre</Label>
                          <Input name="nombreContacto3" value={formData.nombreContacto3} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Puesto</Label>
                          <Input name="puestoContacto3" value={formData.puestoContacto3} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Teléfono</Label>
                          <Input name="telefonoContacto3" value={formData.telefonoContacto3} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Correo</Label>
                          <Input name="correoContacto3" value={formData.correoContacto3} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                    </Row>
                  )}
                  {contacto > 4 && (
                    <Row  >
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Nombre</Label>
                          <Input name="nombreContacto4" value={formData.nombreContacto4} maxLength={100} placeholder="Nombre del contatco" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Puesto</Label>
                          <Input name="puestoContacto4" value={formData.puestoContacto4} maxLength={100} placeholder="Puesto del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Teléfono</Label>
                          <Input name="telefonoContacto4" value={formData.telefonoContacto4} maxLength={100} placeholder="Teléfono del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup >
                          <Label className="floatleft" >Correo</Label>
                          <Input name="correoContacto4" value={formData.correoContacto4} maxLength={100} placeholder="Correo del contacto" onChange={onChanges} />
                        </FormGroup>
                      </div>
                    </Row>
                  )}
                  <Row> <div className="hr" />  <div className="hr" />    </Row>
                  <div>
                    <Button className="floatright" onClick={catalogo} color="danger" >
                      Cancelar
                    </Button>
                    <Button className="floatright" onClick={createClientes} disabled={guardarDisable} color="primary" >
                      Guardar
                    </Button>
                  </div>

                  <Modal isOpen={modal} size="lg" toggle={toggle}>
                    <ModalHeader toggle={toggle}>Datos de Clientes de cotizaciones aprobadas{/*Calculate area*/}</ModalHeader>
                    <ModalBody>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                        <FormGroup >
                          <Label ><h5>Busqueda por: </h5></Label>
                          <select name="recibabusqueda" onChange={"buscarpor"}>
                            <option value="cliente" >Cliente</option>
                            <option value="numero de parte">Número de parte</option>
                            <option value="id de cotizacion" >ID de cotización</option>
                            <option value="fecha">Fecha de cotización</option>
                          </select>
                          <Input
                            type={"searchBy" !== "fecha" ? "text" : "date"}
                            placeholder={"Búsqueda por " + "searchBy"}
                            onChange={"searchBy" !== "fecha" ? "(e) => setSearch(e.target.value)" : "onSearchFecha"}
                            onKeyUp={"searchBy" !== "fecha" ? "onSearch" : ""}
                            value={"search"}
                          />
                        </FormGroup>
                      </div>
                      {/*Enter the measurements of the piece from the largest area to the smallest, please.*/}
                      <Row >
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                          <Table className=" mb-2 scroll ">
                            <Thead class="thead-secondary">
                              <Tr>
                                <Th  >#</Th>
                                <Th className=" minwidth80px">Cliente</Th>
                                <Th className=" minwidth80px">Núm de parte</Th>
                                <Th className=" minwidth80px">ID de Cotización</Th>
                                <Th className=" minwidth80px">Fecha de cotización</Th>
                                <Th className=" minwidth80px">Seleccionar</Th>
                              </Tr>
                            </Thead>
                            <Tbody>

                              {clientesCotizacion.map((x, i) => {
                                return (
                                  !x.seleccionado && (
                                    <Tr class={x.sombreado ? "table-active" : ""} >
                                      <Td>{i + 1}</Td>
                                      <Td >
                                        {x.cliente}
                                      </Td>
                                      <Td >
                                        {x.numerodeParte}
                                      </Td>
                                      <Td >
                                        {x.quoteNumber}
                                      </Td>
                                      <Td >
                                        {x.date}
                                      </Td>
                                      <Td className="textaligmentcenter" >
                                        {/*e => setInputList(handleInputChangeMedidas(e, i, [...inputList])) */}
                                        <button
                                          class="btn-success cbutton "
                                          onClick={() => setClientesCotizacion(seleccionarCliente(x, i, [...clientesCotizacion]))}
                                        ><IoIcons.IoMdCheckmark />
                                        </button>
                                      </Td>
                                    </Tr>
                                  )
                                );
                              })}
                            </Tbody>
                          </Table>

                        </div>
                      </Row>
                    </ModalBody>
                    {/*<div>{JSON.stringify(formData)}</div>*/}
                    <ModalFooter>
                      <Button color="danger" onClick={toggle}>Cerrar</Button>
                    </ModalFooter>
                  </Modal>
                </Fragment>
              )
            }
            {//Editar cliente
              formType === 'Editar Cliente' && (
                <Fragment>
                  <Row >
                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft ">Nombre*</Label>
                        <Input name="cliente" maxLength={50} value={formData.cliente} placeholder="Nombre del cliente" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    {!editarImagen && (
                      <img src={formData.image} alt="imagen" width="100px" title={formData.imagename} />)}
                    <div className={editarImagen ? "col-lg-5 col-md-10 col-sm-10 col-xs-12" : "col-lg-4 col-md-10 col-sm-10 col-xs-12"} >
                      <FormGroup >
                        <Label className="floatleft ">Logo del cliente*</Label>
                        <Input
                          type="file"
                          onChange={onChangeimage}
                        />
                      </FormGroup>
                    </div>

                    <div className="col-lg-1 col-md-2 col-sm-2 col-xs-12">
                      <Label for="activo" className="activofloat">Activo* </Label>
                      <select name="activo" id="activo" className="activofloat" onChange={onChanges}>
                        <option value="true" selected={formData.activo ? true : false}>Sí</option>
                        <option value="false" selected={!formData.activo ? true : false} >No</option>
                      </select>
                    </div>
                  </Row>
                  <Row >
                    <Col>

                      <FormGroup >
                        <Label className="floatleft" >Descripción</Label>
                        <Input name="descripcion" maxLength={800} value={formData.descripcion} type="textarea" placeholder="Descripción" onChange={onChanges} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row >
                    <Col>
                      <FormGroup >
                        <Label className="floatleft" >Domicilio*</Label>
                        <Input name="domicilio" maxLength={300} value={formData.domicilio} type="textarea" placeholder="Domicilio" onChange={onChanges} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Colonia*</Label>
                        <Input name="colonia" maxLength={30} value={formData.colonia} placeholder="Colonia" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Ciudad*</Label>
                        <Input name="ciudad" maxLength={30} value={formData.ciudad} placeholder="Ciudad" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Estado*</Label>
                        <Input name="estado" maxLength={30} value={formData.estado} placeholder="Estado" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >País*</Label>
                        <Input name="pais" maxLength={15} value={formData.pais} placeholder="País" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Código Postal*</Label>
                        <Input name="codigoPostal" maxLength={10} value={formData.codigoPostal} placeholder="Código postal" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row  >
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfonos*</Label>
                        <Input name="telefono" value={formData.telefono} placeholder="Teléfono" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correos*</Label>
                        <Input name="correo" maxLength={100} value={formData.correo} placeholder="Correo" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                      <h4 className="floatleft">Facturación</h4>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                      <Label for="facturaTipo" className="floatleft" >Tipo </Label>
                      <select name="facturaTipo" id="facturaTipo" className="activofloat custom-select" onChange={onChanges}>
                        {!formData.facturaTipo && (<option selected={true} value=" "> </option>)}
                        <option selected={formData.facturaTipo === "Invoice " ? true : false} value="Invoice ">Invoice </option>
                        <option selected={formData.facturaTipo === "Factura foliada" ? true : false} value="Factura foliada">Factura foliada</option>
                      </select>
                    </div>
                    {formData.facturaTipo === "Factura foliada" && (
                      <>
                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                          <Label for="requiereIVA" className="floatleft" >Requiere IVA </Label>
                          <select name="requiereIVA" id="requiereIVA" className="activofloat custom-select" onChange={onChanges}>
                            {!formData.requiereIVA && (<option selected={true} value=" "> </option>)}
                            <option selected={formData.requiereIVA === false ? true : false} value="false">No</option>
                            <option selected={formData.requiereIVA === true ? true : false} value="true">Sí</option>
                          </select>
                        </div>
                        {(formData.requiereIVA === "true" || formData.requiereIVA === true) && (
                          <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <Label for="porcentajeIVA" className="floatleft" >Porcentaje de IVA </Label>
                            <select name="porcentajeIVA" id="porcentajeIVA" className="activofloat custom-select" onChange={onChanges}>
                              {!formData.porcentajeIVA && (<option selected={true} value=" "> </option>)}
                              <option selected={formData.porcentajeIVA === "8 %" ? true : false} value="8 %">8 %</option>
                              <option selected={formData.porcentajeIVA === "16 %" ? true : false} value="16 %">16 %</option>
                            </select>
                          </div>
                        )}
                      </>
                    )}
                  </Row>
                  <Row>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                      <FormGroup >
                        <Label className="floatleft" >RFC</Label>
                        <Input name="rfc" maxLength={30} value={formData.rfc} placeholder="RFC" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                      <FormGroup >
                        <Label className="floatleft" >Razón social</Label>
                        <Input name="razonSocial" maxLength={50} value={formData.razonSocial} placeholder="Razón social" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 margintop20px">
                      <FormGroup >
                        <Label className="floatleft" >Uso del CFDI</Label>
                        <Input name="usoCFDI" maxLength={50} value={formData.usoCFDI} placeholder="Uso del CFDI" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Bill To</Label>
                        <Input name="billTo" value={formData.billTo} type="textarea" placeholder="Bill To" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Ship To</Label>
                        <Input name="shipTo" type="textarea" value={formData.shipTo} placeholder="Ship To" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className=" col-lg-11 col-md-11 col-sm-11 col-xs-11" >
                      <h4 className="floatleft">Contacto</h4>
                    </div>
                    {/*<div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                        <button class="btn-success  floatright" disabled={isDisabled} onClick={nuevoContacto} title="Agregar contacto"> <span class="fa fa-plus lg"></span> </button>     
                            </div>  */}
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Nombre*</Label>
                        <Input name="nombreContacto" maxLength={100} value={formData.nombreContacto} placeholder="Nombre del contatco" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Puesto*</Label>
                        <Input name="puestoContacto" maxLength={100} value={formData.puestoContacto} placeholder="Puesto del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfono*</Label>
                        <Input name="telefonoContacto" maxLength={100} value={formData.telefonoContacto} placeholder="Teléfono del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correo*</Label>
                        <Input name="correoContacto" maxLength={100} value={formData.correoContacto} placeholder="Correo del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Nombre</Label>
                        <Input name="nombreContacto1" maxLength={100} value={formData.nombreContacto1} placeholder="Nombre del contatco" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Puesto</Label>
                        <Input name="puestoContacto1" maxLength={100} value={formData.puestoContacto1} placeholder="Puesto del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfono</Label>
                        <Input name="telefonoContacto1" maxLength={100} value={formData.telefonoContacto1} placeholder="Teléfono del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correo</Label>
                        <Input name="correoContacto1" maxLength={100} value={formData.correoContacto1} placeholder="Correo del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Nombre</Label>
                        <Input name="nombreContacto2" maxLength={100} value={formData.nombreContacto2} placeholder="Nombre del contatco" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Puesto</Label>
                        <Input name="puestoContacto2" maxLength={100} value={formData.puestoContacto2} placeholder="Puesto del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfono</Label>
                        <Input name="telefonoContacto2" maxLength={100} value={formData.telefonoContacto2} placeholder="Teléfono del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correo</Label>
                        <Input name="correoContacto2" maxLength={100} value={formData.correoContacto2} placeholder="Correo del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Nombre</Label>
                        <Input name="nombreContacto3" maxLength={100} value={formData.nombreContacto3} placeholder="Nombre del contatco" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Puesto</Label>
                        <Input name="puestoContacto3" maxLength={100} value={formData.puestoContacto3} placeholder="Puesto del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfono</Label>
                        <Input name="telefonoContacto3" maxLength={100} value={formData.telefonoContacto3} placeholder="Teléfono del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correo</Label>
                        <Input name="correoContacto3" maxLength={100} value={formData.correoContacto3} placeholder="Correo del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row  >
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Nombre</Label>
                        <Input name="nombreContacto4" maxLength={100} value={formData.nombreContacto4} placeholder="Nombre del contatco" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Puesto</Label>
                        <Input name="puestoContacto4" maxLength={100} value={formData.puestoContacto4} placeholder="Puesto del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Teléfono</Label>
                        <Input name="telefonoContacto4" maxLength={100} value={formData.telefonoContacto4} placeholder="Teléfono del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup >
                        <Label className="floatleft" >Correo</Label>
                        <Input name="correoContacto4" maxLength={100} value={formData.correoContacto4} placeholder="Correo del contacto" onChange={onChanges} />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row> <div className="hr" />  <div className="hr" />    </Row>
                  <div>
                    <Button className="floatright" onClick={catalogo} color="danger" >
                      Cancelar
                    </Button>
                    <Button className="floatright" onClick={updateClientes} disabled={guardarDisable} color="primary" >
                      Guardar
                    </Button>
                  </div>
                </Fragment>
              )
            }

          </div>
        </>
      )}
    </>
  )
}

export default Clientes
